module.exports = __webpack_public_path__ + "static/media/downArrow.4b45452d.png";